import LegalPage from './LegalPage';
import { fetchTermsAndConditions } from '../lib/api';

const TermsAndConditions = () => (
  <LegalPage
    pageKey="terms"
    fallbackTitle="Terms & Conditions"
    fetcher={fetchTermsAndConditions}
    description="Read EatMeat's Terms and Conditions to understand your rights and responsibilities while using our app."
    icon="📜"
    accentColor="text-purple-600 bg-purple-50 border-purple-100"
  />
);

export default TermsAndConditions;
